module.exports = __webpack_public_path__ + "static/media/Tech_contentsPage_ko.f0d12fca.png";